import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppState, MetadataService, Metadata, TableRecord } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class TyloMetadataService extends MetadataService {
  constructor(protected store: Store<AppState>, protected translateService: TranslateService) {
    super(store);
  }

  protected getMetadataValueInternal(
    metadata: Metadata,
    tableName: string,
    valueName: string,
    key: string
  ): string | undefined {
    try {
      const lowerKey = ('' + key).toLowerCase();
      const translationKey = 'metadata.' + tableName + '.' + lowerKey + '.' + valueName;
      const translationValue = this.translateService.instant(translationKey);
      if (translationValue && translationValue !== translationKey) {
        return translationValue;
      }
      return super.getMetadataValueInternal(metadata, tableName, valueName, key);
    } catch (ex) {
      console.log('Exception in TyloMetadataService.getMetadataValueInternal');
    }
    return undefined;
  }

  protected getMetadataValuesInternal(
    metadata: Metadata,
    tableName: string,
    keyField: string,
    valueField?: string
  ): { [key: string]: TableRecord | string } {
    if (!metadata[tableName] || !metadata[tableName].list) {
      return {};
    }
    return metadata[tableName].list.reduce(
      (prev, curr) => ({
        ...prev,
        [curr[keyField]]:
          valueField && valueField !== ''
            ? this.getMetadataValueInternal(metadata, tableName, valueField, curr[keyField])
            : curr
      }),
      {}
    );
  }
}
